module.exports = __webpack_public_path__ + "img/first-day-4.a1e82727.png";